import _styled from "@emotion/styled/base";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { createElement as _createElement } from "@emotion/react";
import { useBreakpointDown } from '@travel-frontend/core';
import { useRef } from 'react';
import { ContentLayer } from '../../../primitives/ContentLayer/ContentLayer.js';
import { ContentLayerBody } from '../../../primitives/ContentLayer/ContentLayerBody.js';
import { ContentLayerBottomBar } from '../../../primitives/ContentLayer/ContentLayerBottomBar.js';
import { Header } from '../../../primitives/ContentLayer/TabbedContentLayer/components/Header.js';
import { TabPanel } from '../../../primitives/ContentLayer/TabbedContentLayer/components/TabPanel.js';
import { Tab, Tabs } from '../../../primitives/Tab/index.js';
export const TabbedContentLayer = /*#__PURE__*/_styled(({
  tabs,
  controls,
  onChangeTab,
  visuallyHideTitle,
  ...restProps
}) => {
  const smDown = useBreakpointDown('sm');
  const activeTab = tabs.find(tab => tab.active);
  // @ts-expect-error ...
  const activeTabIndex = tabs.indexOf(activeTab);
  const scrollAreaRef = useRef(null);
  const enabledTabs = tabs.filter(tab => !tab.disabled);
  const enabledTabsWithOverlays = tabs.filter(tab => !tab.disabled && tab.overlay);
  const handleTabChange = index => {
    onChangeTab(tabs[index].id);
    if (scrollAreaRef.current) {
      scrollAreaRef.current.scrollTo(0, 0);
    }
  };
  return _jsxs(ContentLayer, {
    ...restProps,
    visuallyHideTitle: visuallyHideTitle,
    children: [_jsx(Header, {
      visuallyHideTitle: visuallyHideTitle,
      children: _jsx(Tabs, {
        value: activeTabIndex,
        onChange: handleTabChange,
        children: tabs.map(({
          id,
          content,
          active,
          size,
          ...tabProps
        }) => _createElement(Tab, {
          "data-testid": "shared-tabbedContentLayer-tab",
          ...tabProps,
          key: id,
          size: visuallyHideTitle || !smDown ? 'medium' : 'small'
        }))
      })
    }), _jsxs(ContentLayerBody, {
      id: "dialog-content",
      full: true,
      withoutPadding: true,
      style: {
        overflow: 'hidden'
      },
      children: [_jsx("div", {
        ref: scrollAreaRef,
        style: {
          overflowY: 'auto'
        },
        children: enabledTabs.map(({
          id,
          content
        }) => {
          const hidden = activeTab?.id !== id;
          return _jsx(TabPanel, {
            hidden: hidden,
            "data-testid": hidden ? undefined : 'shared-tabbedContentLayer-content',
            children: content
          }, id);
        })
      }), enabledTabsWithOverlays.map(({
        id,
        overlay
      }) => _jsx("div", {
        hidden: activeTab?.id !== id,
        children: overlay
      }, id))]
    }), controls && _jsx(ContentLayerBottomBar, {
      children: controls
    })]
  });
}, process.env.NODE_ENV === "production" ? {
  target: "ezkkm6d0"
} : {
  target: "ezkkm6d0",
  label: "TabbedContentLayer"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");